import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large CompaniesSetPassword",
    title: "Установка пароля",
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitReset
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        placeholder: "Введите пароль",
        value: _ctx.state.password,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.password) = $event)),
        "is-invalid": _ctx.state_form$.password.$error,
        "validation-errors": _ctx.state_form$.password.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}